import { memo } from 'react';
import { token } from '@atlaskit/tokens';
import { css } from '@emotion/react';

import { CardStatus } from '@components/learning/LearningSidebar/constants';
import { SectionsSkeletonLoader } from './skeletons/SectionsSkeletonLoader';
import { SectionItem } from './SectionItem';
import { LessonItem, ProgressForLessons } from '../types';
import { mapLearningProgressToCardStatus } from '../utils/utils';

export interface LessonSectionsProps {
  lesson: LessonItem;
  progressForLesson?: ProgressForLessons['lessons'][0];
  isLoading: boolean;
  courseSlug?: string;
  selectedSectionId?: string;
  currentLessonSlug?: string;
  onSelect: (courseSlug: string, lessonSlug?: string, sectionSlug?: string) => void;
  isLessonCardExpanded: boolean;
  isMobile: boolean;
}

export const LessonSections: React.FC<LessonSectionsProps> = memo((props) => {
  const {
    lesson: { slug, sectionListCollection },
    progressForLesson,
    isLoading,
    courseSlug,
    selectedSectionId,
    currentLessonSlug,
    onSelect,
    isLessonCardExpanded,
    isMobile,
  } = props;

  if (isLoading && isLessonCardExpanded) {
    return <SectionsSkeletonLoader />;
  }

  if (!isLessonCardExpanded || isMobile) {
    return null;
  }

  const status = mapLearningProgressToCardStatus(progressForLesson?.status);

  return (
    <div css={sectionContainerStyles}>
      {sectionListCollection.items.map((section) => {
        const sectionStatus =
          section.id === 'quiz' && status === CardStatus.COMPLETED
            ? CardStatus.COMPLETED
            : mapLearningProgressToCardStatus(
                progressForLesson?.section.find((sectionProgress) => sectionProgress.sectionId === section.sys.id)
                  ?.status,
              );

        return (
          <SectionItem
            key={section.id}
            section={section}
            status={sectionStatus}
            onSelect={onSelect}
            lessonSlug={slug}
            courseSlug={courseSlug}
            isSelected={currentLessonSlug === slug && section.sys.id === selectedSectionId}
          />
        );
      })}
    </div>
  );
});

const sectionContainerStyles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  marginLeft: token('space.200'),
  marginTop: token('space.100'),
});
